import { styled } from '@/stitches.config';
import { Box } from '@base-app';
import { ReactComponent as ErrorIcon } from '@assets/icons/error.svg';
import { ReactComponent as SuccessIcon } from '@assets/icons/success.svg';
import { ReactComponent as InfoIcon } from '@assets/icons/info.svg';
import { ReactComponent as ExitIcon } from '@assets/icons/exit.svg';

export const NotificationStyled = styled(Box, {
  borderRadius: '$3',
  display: 'flex',
  flexDirection: 'space-around',

  variants: {
    variant: {
      error: {
        backgroundColor: '$red800',
      },
      success: {
        backgroundColor: '$green700',
      },
      info: {
        backgroundColor: '$blue700',
      },
    },
    textAlign: {
      left: {
        textAlign: 'left',
      },
      center: {
        textAlign: 'center',
      },
      right: {
        textAlign: 'right',
      },
    },
    banner: {
      true: {
        boxShadow: '$banner',
      },
    },
  },

  defaultVariants: {
    textAlign: 'center',
  },
});

export const SuccessIconStyled = styled(SuccessIcon, {
  height: '$6',
  width: '$6',
  color: '$green',
});

export const ErrorIconStyled = styled(ErrorIcon, {
  height: '$6',
  width: '$6',
  color: '$error',
});

export const InfoIconStyled = styled(InfoIcon, {
  height: '$6',
  width: '$6',
  color: '$blue',
});

export const StyledCloseButton = styled(Box, {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  marginLeft: 'auto',
  paddingRight: '$4',
});

export const StyledExitIcon = styled(ExitIcon, {
  color: '$darkGray300',
  height: '$6',
  width: '$6',
});
